<template>
  <div>
    <v-data-table :headers="headers" :items="listUsers" class="elevation-1">
      <template v-slot:item.action="{ item }">
        <v-icon class="mr-2" @click="editItem(item)">edit</v-icon>
        <v-icon @click="deleteItem(item)" >delete</v-icon>
      </template>
    </v-data-table>

    <v-layout justify-center>
       <router-link to="/users/create">
        <v-btn color="red" fab small dark fixed bottom justify-center>
          <v-icon>add</v-icon>
        </v-btn>
      </router-link>
    </v-layout>

  </div>
</template>

<script>
export default {
  name: 'list-users',
  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: 'Email',
          align: 'center',
          value: 'email',
          sortable: true,
        },
        {
          text: 'Rol',
          align: 'center',
          value: 'type',
          sortable: true,
        },

        {
          text: 'Activ',
          align: 'center',
          value: 'isActive',
          sortable: true,
        },

        {
          text: 'Actions',
          value: 'action',
          sortable: false,
        },
      ],
      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  created() {
    this.$store.dispatch('users/getUsers');
  },
  computed: {
    listUsers() {
      return this.$store.state.users.users;
    },
  },
  methods: {
    editItem(item) {
      this.$router.push({ path: `/users/${item.id}` });
    },
    deleteItem(item) {
      if (window.confirm('Sunteti sigur?')) {
        this.$store.dispatch('users/delete', item.id);
      }
    },
  },
};
</script>
